import React from "react";

const PrevStepButton = (props) => {
  return (
    <button
      type="button"
      className="btn btn-secondary btn-prev mr-2 mb-3"
      onClick={props.onClick}
    >
      <i className="fas fa-arrow-left"></i>Wstecz
    </button>
  );
};

export default PrevStepButton;
